import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseTrackListeningScoreParams {
  trackId: string;
  date?: Date;
  rangeDays?: number;
  enabled?: boolean;
}

export const useTrackListeningScore = ({ trackId, date, rangeDays, enabled = true }: UseTrackListeningScoreParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  return useTRPCQuery(
    trpcMusicAPI.tracks.listeningScore.queryOptions(
      { trackId, date, rangeDays, ...shareTokenInput },
      { enabled: Boolean(trackId) && enabled }
    )
  );
};
